import Location from 'react-app-location';

export const FinishedRequestsLocation = new Location('/requests/finished');
